/**
 * Domain for cookies shared across the Oppizi apps (theme, sidebar state — PAD-31716).
 *
 * Returns the widest registrable domain the current host lives under so the
 * cookie is readable by every sub-app (platform-next, this builder, etc.).
 * `''` on localhost/unknown → cookie-state omits the domain attribute, giving a
 * host-only cookie, still shared across ports (localhost:3001 ↔ :3002) since
 * cookies ignore the port. (cookie-state types `domain` as a required string,
 * so we return '' rather than undefined.)
 */
export function sharedCookieDomain(): string {
  const host = window.location.hostname;
  for (const base of ["oppizi.com", "promofy.marketing"]) {
    if (host === base || host.endsWith(`.${base}`)) return `.${base}`;
  }
  return "";
}
